import type { PopularQueryParams } from '@/lib/api/requests/recipe-views';

export const recipeViewKeys = {
  all: ['recipe-views'] as const,
  popular: (params?: PopularQueryParams) => [...recipeViewKeys.all, 'popular', params ?? {}] as const,
};
